import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 0 8rem;
  margin: 0 auto;
  width: 100%;
  justify-content: space-between;
  height: 4rem;
  position: fixed;
  top: 0;
  border-bottom: 1px solid var(--gray-200);
  z-index: 1;
  background: #FFF;
  
  .mobile-header {
    width: 2rem;
    height: 2rem;
    display: none;
  }

  img {
    width: 11rem;
    cursor: pointer;
  }

  .buttons-container {
    display: flex;
    gap: 1rem;

    button {
      background: 0;
      border: 0;
      
      &:first-child {
      margin-right: 0.25rem;
     }
      img {
        width: 2.4rem;
        transition: .4s;
      }
      &:hover {
        img {
          transform: scale(1.1);
        }
      }
    }
  }

  @media (max-width: 850px) {
    padding: 0 2rem;

    .buttons-container {
      gap: 0;
      button {
        &:first-child {
          margin-right: 1rem;
        }
      }
    }
  }

  @media (max-width: 720px) {
    #ocariot-logo, #home-button {
      display: none;
    }
    .mobile-header {
      display: inline;
    }
  }
`;

export const Popover = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 4rem;
  right: 8rem;
  margin-top: 10px;
  width: 250px;
  padding: 10px 0;
  border-radius: 10px;

  @media (max-width: 850px) {
    right: 2rem;
  }
  
  transition:  0.4s;
  
  ${props => props.isFocused ? css`
    height: 170px;
    box-shadow: 0px 2px 5px #0000008c;
    background: #FFF;
  ` : 
  css`
    height: 0;
  `};

  ${props => props.maxHeight && css`
    height: 350px;
    .toggle-bnt {
      position: absolute;
      top: 50px;
      transition: 2s;
    }
  `}

  a, strong {
    animation: fade 2s;
    padding: 10px 0;
    font-size: 1rem;
    width: 100%;
    text-align: center;
    white-space: nowrap;
    color: var(--color-primary);
    text-decoration: none;
    transition: 0.2s;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid var(--gray-200);

    &:last-child {
      border-bottom: 0;
      padding-bottom: 0;
    }
  }
`;

export const ChangePass = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid var(--gray-200);
  animation: fade 2s;

  ${props => props.isFocused ? css`
    height: 220px;
  ` : 
  css`
    height: 40px;
  `};

  form {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 30px;
    margin-top: 50px;
    position: relative;
    animation: fade 2s;
    
    .input-div {

    }
    

    label {
      font-size: 0.9rem;
    }
    footer {
      
      display: flex;
      width: 100%;
      justify-content: flex-end;
    }
    .change-pass-bnt {
      background: var(--light-blue);
      border: 0;
      color: #FFF;
      border-radius: 0.25rem;
      padding: 10px;
      width: 50%;
      
    }
  }

  .toggle-bnt {
    position: absolute;
    top: 50px;
    border: 0;
    background: #FFF;
    height: 39px;
    font-size: 1rem;
    width: 100%;
    text-align: center;
    white-space: nowrap;
    color: var(--color-primary);
    text-decoration: none;

    svg {
      position: absolute;
      right: 20px;
    }
  }
`;